<!-- 结果弹窗 -->
<template>
  <div class="result-popup">
    <van-overlay
      :show="show"
      @click="close"
      :lock-scroll="false"
      class="my-overlay"
    >
      <div class="wrapper" @click.stop>
        <img
          v-if="iconMap[iconKey]"
          class="pic"
          :src="iconMap[iconKey]"
          alt=""
        />
        <p class="title">{{ title }}</p>
        <p class="text">{{ message }}</p>
        <img
          class="btn"
          @click="close"
          :src="
            require(`@/assets/imgs/putianPostalNationalDayLottery/pic3.png`)
          "
          alt=""
        />
      </div>
      <img
        v-if="isClose"
        class="close"
        @click="close"
        :src="require(`@/assets/imgs/putianPostalNationalDayLottery/close.png`)"
        alt=""
      />
    </van-overlay>
  </div>
</template>
<script>
import { Toast } from 'vant'
export default {
  components: {},
  props: [],
  data() {
    return {
      show: false,
      iconMap: {
        0: require(`@/assets/imgs/putianPostalNationalDayLottery/pic1.png`),
        1: require(`@/assets/imgs/putianPostalNationalDayLottery/pic2.png`),
      },
      iconKey: '',
      title: '',
      message: '',
      isClose: false
    }
  },
  methods: {
    close() {
      this.setShow(false)
    },
    setShow(val) {
      this.show = val
    },
  },
}
</script>
<style lang="less" scoped>
.result-popup {
  position: relative;
  .my-overlay {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
  }

  .wrapper {
    padding: 30px 15px;
    width: 250px;
    height: 350px;
    box-sizing: border-box;
    border: 5px solid #abd0fa;
    background: #ddecff;
    border-radius: 10px;
    text-align: center;
    font-size: 20px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    .pic {
      width: 120px;
    }

    .title {
      padding: 10px 0;
      line-height: 1.2;
      font-weight: bold;
      font-size: 25px;
      color: #2858c9;
    }
    .text {
      line-height: 1.2;
      font-size: 14px;
    }
    .btn {
      margin-top: 35px;
      width: 109px;
    }
  }
  .close {
    margin-top: 20px;
    width: 35px;
  }
}
</style>
